import React from 'react';

import { Surface } from '@infoods/lifebase-ui';
import ThumbUpAltOutlinedIcon from '@mui/icons-material/ThumbUpAltOutlined';

import classes from './CustomerSuccessWidget.module.scss';
import { StatisticInfoCard } from '../../../../../shared/components/StatisticInfoCard/StatisticInfoCard';
import { WidgetTitle } from '../../../../components/WidgetTitle/WidgetTitle';
import { useNutritionCustomerSuccess } from './hooks/useNutritionCustomerSuccess';
import { getValueOrDash } from '../../../../../shared/utils/stringUtils/getValueOrDash/getValueOrDash';

const CustomerSuccessWidget = () => {
  const { customerSuccess } = useNutritionCustomerSuccess();

  return (
    <Surface radius="l" className={classes.container}>
      <WidgetTitle
        title="Customer Success"
        icon={<ThumbUpAltOutlinedIcon fontSize="small" />}
      />
      {customerSuccess && (
        <div className={classes.row}>
          <StatisticInfoCard
            title="Fat Loss"
            value={getValueOrDash(customerSuccess.fatLoss, ' lbs')}
          />
          <StatisticInfoCard
            title="Muscle Gained"
            value={getValueOrDash(customerSuccess.muscleGain, ' lbs')}
          />
        </div>
      )}
    </Surface>
  );
};

export { CustomerSuccessWidget };
